export const fields = [
  "breakfast_id",
  "lunch_starter_id",
  "lunch_id",
  "snack_id",
  "dinner_starter_id",
  "dinner_id",
];
